import { pdfjs } from 'react-pdf';
// Vite bundles this and emits the worker to dist; new URL(..., import.meta.url) fails in production.
// eslint-disable-next-line import/no-extraneous-dependencies
import workerSrc from 'pdfjs-dist/build/pdf.worker.min.mjs?url';

export function setupPdfWorker() {
  pdfjs.GlobalWorkerOptions.workerSrc = workerSrc;
}
